import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import mapRegistration from './mapRegistration';
import Registration from './Registration';

export interface Result {
	registration: Registration;
}

export default async function findRegistration(client: ApiClient, id: string): Promise<Result> {
	const url = parseTemplate('analytics/virtual-brands/{id}/registrations');
	const request = await client.fetch(url.expand({ id }));
	const response = await request.json();
	return { registration: mapRegistration(response.registration) };
}
